import React from "react";
import { Col, Container, Row, Image, Button } from "react-bootstrap";
import { AiOutlineArrowRight, AiOutlineSearch } from "react-icons/ai";
import { BsArrowRight } from "react-icons/bs";
export const SectionOne = () => {
  return (
    <Container fluid className="bgImage py-4">
      <Container>
        <Row className="align-items-end">
          <Col lg="8">
            <Row className="mt-8">
              <Col lg="8">
                <div>
                  <h2 className="text-5xl font-extrabold">
                    Airport Transfer
                    <br />
                    <span style={{ color: "#00803E" }}>
                      {" "}
                      Service in Pakistan
                    </span>
                  </h2>
                  <h3 className="text-sm font-bold text-black">
                    Book With An Approved, Fixed-price, And Reliable Taxi
                    Company To Pay Online Securely And You Can Book Months In
                    Advance.
                  </h3>
                  <button className="text-white rounded-lg bgGreen py-2 px-5 d-flex gap-2 align-items-center my-3">
                    Booking Now <BsArrowRight />
                  </button>
                </div>
              </Col>
              <Col lg="4">
                <div className="mt-6">
                  <Image src={require("../../assets/mainAiro.png")} />
                </div>
              </Col>
            </Row>
            <Row className="pt-11">
              <Col lg="12">
                <div>
                  <Image
                    style={{ position: "relative", zIndex: "1" }}
                    src={require("../../assets/cars.png")}
                  />
                </div>
              </Col>
            </Row>
          </Col>
          <Col lg="4">
            <div className="webkit p-2 py-5">
              <div className="contactForm webkit text-white">
                <h2 className="text-lg">INSTANT QUOTES</h2>
                <h2 className="text-2xl colorGreen font-bold">
                  AND ONLINE BOOKING
                </h2>
                <form>
                  <fieldset>
                    <div className="About_main_images_search">
                      <input
                        placeholder="Pickup Location"
                        className="border-white"
                      ></input>
                      <AiOutlineSearch
                        size={25}
                        className="text-black border-rounded"
                      />
                      {/* <Button>Search</Button> */}
                    </div>
                  </fieldset>
                  <fieldset>
                    <div className="About_main_images_search">
                      <input
                        placeholder="Add Via Location"
                        className="border-white"
                      ></input>
                      <AiOutlineSearch
                        size={25}
                        className="text-black border-rounded"
                      />
                      {/* <Button>Search</Button> */}
                    </div>
                  </fieldset>
                  <fieldset>
                    <div className="About_main_images_search">
                      <input
                        placeholder="Drop off Location"
                        className="border-white"
                      ></input>
                      <AiOutlineSearch
                        size={25}
                        className="text-black border-rounded"
                      />
                      {/* <Button>Search</Button> */}
                    </div>
                  </fieldset>
                  <div className="d-flex gap-2">
                    <fieldset className="w-6/12">
                      <div className="About_main_images_search">
                        <input
                          type="text"
                          placeholder="Pickup Date"
                          className="border-white"
                        ></input>
                        {/* <AiOutlineSearch
                          size={25}
                          className="text-black border-rounded"
                        /> */}
                        {/* <Button>Search</Button> */}
                      </div>
                    </fieldset>
                    <fieldset className="w-6/12">
                      <div className="About_main_images_search">
                        <input
                          type="text"
                          placeholder="Pickup Time"
                          className="border-white"
                        ></input>
                        {/* <AiOutlineSearch
                          size={25}
                          className="text-black border-rounded"
                        /> */}
                        {/* <Button>Search</Button> */}
                      </div>
                    </fieldset>
                  </div>
                  <div className="d-flex gap-2">
                    <fieldset className="w-6/12">
                      <div className="About_main_images_search">
                        <input
                          type="text"
                          placeholder="Return Date"
                          className="border-white"
                        ></input>
                        {/* <AiOutlineSearch
                          size={25}
                          className="text-black border-rounded"
                        /> */}
                        {/* <Button>Search</Button> */}
                      </div>
                    </fieldset>
                    <fieldset className="w-6/12">
                      <div className="About_main_images_search">
                        <input
                          type="text"
                          placeholder="Return Time"
                          className="border-white"
                        ></input>
                        {/* <AiOutlineSearch
                          size={25}
                          className="text-black border-rounded"
                        /> */}
                        {/* <Button>Search</Button> */}
                      </div>
                    </fieldset>
                  </div>
                  <fieldset>
                    <div className="About_main_images_search">
                      <select name="format" id="format" className="w-full">
                        <option selected disabled>
                          Passenger Count
                        </option>
                        <option value="pdf">1</option>
                        <option value="txt">2</option>
                        <option value="txt">3</option>
                        <option value="txt">4</option>
                        <option value="epub">5</option>
                        <option value="fb2">6</option>
                        <option value="mobi">7</option>
                      </select>

                      {/* <Button>Search</Button> */}
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
